import React from 'react';
import LegalPageLayout, { LegalSub, LegalContact } from '../components/legal/LegalPageLayout';

const TermsOfServicePage = () => {
  const sections = [
    {
      id: 'acceptance',
      title: 'Acceptance of Terms',
      body: (
        <>
          <p>By accessing and using this website operated by Fortschritt Medical Supplies Inc., you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use this website or our services.</p>
          <p>These terms are governed by the laws of the Republic of the Philippines, including but not limited to the Civil Code, Electronic Commerce Act (Republic Act No. 8792), and Consumer Act of the Philippines (Republic Act No. 7394).</p>
        </>
      ),
    },
    {
      id: 'use-of-website',
      title: 'Use of Website',
      body: (
        <>
          <LegalSub>2.1 Permitted Use</LegalSub>
          <p>This website is intended for use by healthcare professionals, medical institutions, and authorized personnel in the Philippines. You may use this website for lawful purposes only, including:</p>
          <ul className="premium-list space-y-2.5">
            <li>Researching product information for medical devices</li>
            <li>Requesting product quotes and documentation</li>
            <li>Downloading Instructions for Use (IFU) and product brochures</li>
            <li>Contacting our sales representatives</li>
          </ul>
          <LegalSub>2.2 Prohibited Activities</LegalSub>
          <p>You agree not to:</p>
          <ul className="premium-list space-y-2.5">
            <li>Use the website for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Distribute malware, viruses, or harmful code</li>
            <li>Reproduce, duplicate, or resell website content without permission</li>
            <li>Misrepresent your identity or affiliation</li>
            <li>Use automated systems to scrape or harvest content</li>
          </ul>
        </>
      ),
    },
    {
      id: 'product-information',
      title: 'Product Information and Ordering',
      body: (
        <>
          <p>All FlexiOss® products are PH-FDA certified medical devices (Class III) intended for use by trained healthcare professionals. Product information on this website is for informational purposes only and does not constitute medical advice.</p>
          <p>Product availability, specifications, and pricing are subject to change without notice. Orders are subject to acceptance by Fortschritt Medical Supplies Inc. We reserve the right to refuse or cancel any order at our discretion.</p>
        </>
      ),
    },
    {
      id: 'intellectual-property',
      title: 'Intellectual Property Rights',
      body: (
        <>
          <p>All content on this website, including text, graphics, logos, images, videos, and software, is the property of Fortschritt Medical Supplies Inc., Medical Inventi, or our licensors and is protected by Philippine and international copyright laws.</p>
          <p>FlexiOss® and TriCurean® are registered trademarks. Unauthorized use of these trademarks is strictly prohibited and may violate intellectual property laws under Republic Act No. 8293 (Intellectual Property Code of the Philippines).</p>
        </>
      ),
    },
    {
      id: 'limitation-of-liability',
      title: 'Limitation of Liability',
      body: (
        <>
          <p>To the fullest extent permitted by Philippine law, Fortschritt Medical Supplies Inc. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from:</p>
          <ul className="premium-list space-y-2.5">
            <li>Use or inability to use this website</li>
            <li>Errors or inaccuracies in website content</li>
            <li>Unauthorized access to your personal information</li>
            <li>Interruption or cessation of website services</li>
            <li>Third-party content or links</li>
          </ul>
        </>
      ),
    },
    {
      id: 'warranty-disclaimer',
      title: 'Warranty Disclaimer',
      body: (
        <>
          <p>This website and its content are provided "as is" without warranties of any kind, either express or implied. We do not warrant that:</p>
          <ul className="premium-list space-y-2.5">
            <li>The website will be uninterrupted, secure, or error-free</li>
            <li>Information provided is accurate, complete, or current</li>
            <li>Defects will be corrected</li>
            <li>The website is free from viruses or harmful components</li>
          </ul>
        </>
      ),
    },
    {
      id: 'governing-law',
      title: 'Governing Law and Dispute Resolution',
      body: (
        <p>These Terms of Service shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising from these terms or your use of this website shall be subject to the exclusive jurisdiction of the courts of Pasig City, Metro Manila, Philippines.</p>
      ),
    },
    {
      id: 'contact',
      title: 'Contact Information',
      body: <LegalContact intro="For questions regarding these Terms of Service, please contact:" />,
    },
  ];

  return (
    <LegalPageLayout
      testId="terms-of-service-page"
      title="Terms of Service"
      subtitle="The terms governing your access to and use of the FlexiOss® Philippines website and services."
      updated="December 2024"
      sections={sections}
    />
  );
};

export default TermsOfServicePage;
